import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Nodata from "../../sharedComponents/Nodata";
import RenderHtml from "../../sharedComponents/RenderHtml";
import OnePageOrderProd from "./OnePageOrderProd";
import OnePageFooter from "./OnePageFooter";
import Popup from "../../sharedComponents/Popup";
function OnePageOrder() {
  const [noPage, setNoPage] = useState(false);
  const [orderData, setOrderData] = useState(null);
  const [storeData, setStoreData] = useState(null);
  const [orderdetailData, setOrderdetailData] = useState(null);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const ordernoValue = queryParams.get("orderno");
  const tokenValue = queryParams.get("token");
  const getOrderData = () => {
    const requestData = { orderno: ordernoValue, token: tokenValue };
    axios
      .post("api/Onepage/OPfinishOrder", requestData)
      .then((response) => {
        console.log("OPfinishOrder:", "response.data");
        setOrderData(response.data.orderQuery);
        setStoreData(response.data.storeData);
        setOrderdetailData(response.data.orderItems);
      })
      .catch((error) => {
        console.error("Error OPfinishOrder fetching data:", "error");
        // Log a message for when products are not found
        setNoPage(true);
        console.log("requestData", "requestData");
        if (error.response && error.response.status === 404) {
          console.log("error.response");
        }
      });
  };
  useEffect(() => {
    if (ordernoValue && tokenValue) {
      console.log("ordernoValue", "ordernoValue");
      console.log("tokenValue", "tokenValue");
      getOrderData();
    }
  }, [ordernoValue, tokenValue]);
  return (
    <>
      {noPage && !orderData && (
        <div className="onepage">
          <div className="container-fluid px-0">
            <Popup
              onNevigate={() => {
                setNoPage(false);
                navigate("/");
              }}
              onClose={() => {
                setNoPage(false);
              }}
              icon={"notice"}
              title={"查無此訂單"}
              orangebtn={"回到首頁"}
              greenbtn={""}
            />
          </div>
        </div>
      )}
      {orderData && (
        <div className="onepage">
          <div className="container pt-5 checkout-4 justify-content-center onepage-order">
            <div className="checkout-select">
              <div className="order-info">
                <div className="order-check">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    fill="none"
                  >
                    <path
                      d="M40 0C17.9087 0 0 17.9087 0 40C0 62.0913 17.9087 80 40 80C62.0913 80 80 62.0913 80 40C80 17.9087 62.0913 0 40 0ZM40 8.6914C57.2913 8.6914 71.3037 22.7131 71.3037 40C71.3037 57.287 57.2913 71.3037 40 71.3037C22.7087 71.3037 8.69627 57.287 8.69627 40C8.69633 22.7131 22.7087 8.6914 40 8.6914ZM55.3271 21.0059L32.1435 44.1943L24.624 36.6748L17.2461 44.0479L24.7656 51.5674L32.1923 58.9941L39.5655 51.6162L62.7539 28.4326L55.3271 21.0059Z"
                      fill="#C0DAC3"
                    />
                  </svg>
                  <h6 className="primary-deep">感謝您的訂購，訂單已成立！</h6>
                </div>
                <div className="d-flex flex-column gap-10px ">
                  

                  <div className="order-detail">
                    <div className="content">
                      <div className="title">
                        <p>訂單編號</p>
                        <p>：</p>
                      </div>
                      <div className="descript-container">
                        <p className="p1">{orderData.orderNo}</p>
                      </div>
                    </div>
                    <div className="content">
                      <div className="title">
                        <p>付款方式</p>
                        <p>：</p>
                      </div>
                      <div className="descript-container">
                        <p>{orderData.paymentMethod}</p>
                        {/* <p>{orderData.paymentId}</p> */}
                        {/* {orderData.paymentId === "1"  &&(<p>信用卡付款</p>)}
                      {orderData.paymentId === "2"  &&(<p>銀行轉帳付款</p>)}
                      {orderData.paymentId === "3" &&(<p>貨到付款</p>)} */}
                      </div>
                    </div>
                    <div className="content">
                      <div className="title">
                        <p>付款狀態</p>
                        <p>：</p>
                      </div>
                      <div className="descript-container">
                        <p>{orderData.paymentStatus}</p>
                      </div>
                    </div>
                    <div className="content">
                      <div className="title">
                        <p>總金額</p>
                        <p>：</p>
                      </div>
                      <div className="descript-container">
                        <p>${orderData.orderPrice.toLocaleString()}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="popup-footer">
                <div className="pt-5">
                  <div className="footer-bottom ">
                    {/* {orderData.paymentId === "2" && storeData && (
                    <>
                      <p className="danger">
                        ※請於兩天內繳款，否則訂單將取消。
                      </p>
                      <p className="primary-deep2">轉帳完成後：</p>
                      <p>
                        透過「會員專區」{">"}
                        「訂單資料」的「回傳匯款資料」功能將「匯款日期、轉帳帳號後5碼」回傳至本公司，以便確認付款資訊，如有任何問題歡迎來電洽詢。
                      </p>
                    </>
                  )} */}
                    <div className="d-flex">
                      <p>服務電話：</p>
                      <p>{storeData.contactTel}</p>
                    </div>
                    <div className="d-flex">
                      <p>電子信箱：</p>
                      <p>{storeData.contactEmail}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="checkout-select py-5 container-fluid checkout-container">
              <div className="page-content">
                <div className="section-title">
                  <div className="title">
                    <h5>訂單內商品清單</h5>
                  </div>
                </div>
                <div className="overflow-wrap">
                  <div className="overflow">
                    <div className="checkout-content pe-2 pb-0">
                      {orderdetailData &&
                        orderdetailData.map((item, index) => (
                          <OnePageOrderProd key={index} cartitem={item} />
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <OnePageFooter />
        </div>
      )}
    </>
  );
}

export default OnePageOrder;
